import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { STATUS_LABEL } from "../lib/api";

/**
 * Destructive confirmation dialog used by Secretariat to delete a GO/WFH request.
 * `deleteFor` is `{id, type, employee_name, status}` or null when closed.
 * Shows additional warning when status is final (decided/sent) — force=true on backend.
 */
export function DeleteRequestDialog({ deleteFor, onCancel, onConfirm, busy }) {
  return (
    <Dialog open={!!deleteFor} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700">
            <AlertTriangle className="w-5 h-5"/>Obriši zahtjev
          </DialogTitle>
        </DialogHeader>
        {deleteFor && (
          <div className="space-y-2 text-sm">
            <p>Sigurno želite obrisati {deleteFor.type === "wfh" ? "WFH" : "GO"} zahtjev od <b>{deleteFor.employee_name}</b>?</p>
            <p className="text-xs text-muted-foreground">Trenutni status: <b>{STATUS_LABEL[deleteFor.status]}</b></p>
            {["decided", "sent"].includes(deleteFor.status) && (
              <div className="bg-red-50 border border-red-200 rounded p-2 text-xs text-red-700">
                <b>Pažnja:</b> Rješenje je već izdano{deleteFor.status === "sent" ? " i poslano" : ""}.
                Brisanjem se trajno uklanja iz sustava, ali se već poslani PDF/e-mail neće povući.
              </div>
            )}
            <p className="text-[11px] text-muted-foreground">Akcija se bilježi u audit log.</p>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="del-req-cancel">Odustani</Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy} data-testid="del-req-confirm">
            {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin"/> : <Trash2 className="w-4 h-4 mr-1"/>}
            Obriši
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
